<template>
	<Modals
		:title="title"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="closeModal"
		:novalidate="'novalidate'"
		:fullMobile="true"
	>
		<template #modal-content>
			<div >
				{{ contentText }}
			</div>
		</template>
		<template #modal-footer>
			<Button
				className="btn--primary"
				labelText="Close"
				:btnClick="closeModal"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Button from '@/components/forms/button/button';

export default {
	name: 'VendorIntegrationSpecificationModal',
	components: {
		Modals,
		Button
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		contentText:{
			type: String,
			default: ''
		}
	},
	data() {
		return {
			privilegedUser: true
		};
	},
	computed: {
		isConfirmation() {
			return this.type == 'confirmation';
		}
	},
	methods: {
		closeModal() {
			if (!this.validateBeforeClose) {
				this.$emit('show', false);
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
